import { render, staticRenderFns } from "./ReceipsPayment.vue?vue&type=template&id=0d2cd050"
import script from "./ReceipsPayment.vue?vue&type=script&lang=js"
export * from "./ReceipsPayment.vue?vue&type=script&lang=js"
import style0 from "./ReceipsPayment.vue?vue&type=style&index=0&id=0d2cd050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports